// src/components/apps/c64/C64MappingsTab.js
import * as React from 'react';
import Box from '@mui/material/Box';

import EditorTabPanel from '../../common/editor/EditorTabPanel';
import EditorSelect from '../../common/editor/EditorSelect';
import { OPTIONS } from './C64MappingOptions';

// i18n
import { useI18n } from '../../../i18n/I18nContext';

function MappingField(props) {
  const {
    label,
    buttonName,
    object,
    setObject
  } = props;

  const { t } = useI18n();
  const NONE = 'none';

  let value = NONE;
  if (object.props.mappings) {
    value = object.props.mappings[buttonName];
    if (!value) {
      value = NONE;
    }
  }

  const setValue = (str) => {
    let mappings = object.props.mappings;
    if (!mappings) {
      mappings = {};
    }

    if (str === NONE) {
      delete mappings[buttonName];
    } else {
      mappings[buttonName] = str;
    }

    const props = { ...object.props, mappings: mappings };
    setObject({ ...object, props });
  };

  const menuItems = [];
  // Antes: "(none)"
  menuItems.push({ value: NONE, name: t('c64MapNone') });

  for (let i = 0; i < OPTIONS.length; i++) {
    const opt = OPTIONS[i];
    // Por enquanto usamos o label original do OPTIONS
    menuItems.push({ value: opt.value, name: opt.label });
  }

  // Ensure value is in values
  let found = false;
  for (let i = 0; i < menuItems.length; i++) {
    const item = menuItems[i];
    if (item.value === value) {
      found = true;
      break;
    }
  }

  if (!found) {
    value = NONE;
  }

  return (
    <div>
      <EditorSelect
        label={label}
        value={value}
        menuItems={menuItems}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
    </div>
  );
}

export default function C64MappingsTab(props) {
  const {
    tabValue,
    tabIndex,
    setObject,
    object
  } = props;

  const { t } = useI18n();

  return (
    <EditorTabPanel value={tabValue} index={tabIndex}>
      <Box sx={{ m: 1.5 }}>
        {t('c64MapIntro')}
      </Box>
      <MappingField
        label={t('c64MapStart')}
        buttonName="start"
        object={object}
        setObject={setObject}
      />
      {/* <MappingField label="Left" buttonName="left" object={object} setObject={setObject} />
      <MappingField label="Right" buttonName="right" object={object} setObject={setObject} />
      <MappingField label="Up" buttonName="up" object={object} setObject={setObject} />
      <MappingField label="Down" buttonName="down" object={object} setObject={setObject} /> */}
      <MappingField
        label={t('c64MapAButton')}
        buttonName="a"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapBButton')}
        buttonName="b"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapXButton')}
        buttonName="x"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapYButton')}
        buttonName="y"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapLeftBumper')}
        buttonName="lb"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapRightBumper')}
        buttonName="rb"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapLeftTrigger')}
        buttonName="lt"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapRightTrigger')}
        buttonName="rt"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapRightAnalogLeft')}
        buttonName="ra-left"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapRightAnalogRight')}
        buttonName="ra-right"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapRightAnalogUp')}
        buttonName="ra-up"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('c64MapRightAnalogDown')}
        buttonName="ra-down"
        object={object}
        setObject={setObject}
      />
    </EditorTabPanel>
  );
}